import {useCallback, useState} from "react";
import useStore from "./useStore";

interface UseApiReturn<T> {
    loading: boolean;
    error: any;
    data: T | null;
    get: (url: string) => Promise<void>;
    post: (url: string,json:boolean, body: any) => Promise<void>;
    put: (url: string, body: any) => Promise<void>;
    remove: (url: string) => Promise<void>;
}

const useApi = <T = any>(): UseApiReturn<T> => {
    const {accessToken} = useStore()
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<any>(null);
    const [data, setData] = useState<any>(null);


    const request = useCallback(
        async (url: string, options: RequestInit) => {
            setLoading(true);
            setError(null);

            try {
                const res = await fetch(url, options);
                const result = await res.json();

                if (!res.ok) {
                    throw result;
                }

                setData(result);
                return result;
            } catch (err) {
                setError(err);
                console.error(err);
                throw err;
            } finally {
                setLoading(false);
            }
        },
        []
    );

    const get = useCallback((url: string) =>{
        return request(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${accessToken}`,
            },
        })
    }, [request, accessToken]);


    const post = async (url: string,json:any, body: any) => {
        const headers:any = {
            'Authorization': `Bearer ${accessToken}`
        }
        if (json) {
            headers['Content-Type'] = 'application/json';
        }
        return request(url, {
            method: "POST",
            headers: headers,
            body: body,
        });
    };

    const put = async (url: string, body: any) => {
        return request(url, {
            method: "PUT",
            headers: { "Content-Type": "application/json",'Authorization': `Bearer ${accessToken}` },
            body: JSON.stringify(body),
        });
    };

    const remove = async (url: string) => {
        return request(url, {
            method: "DELETE",
            headers: { "Content-Type": "application/json",'Authorization': `Bearer ${accessToken}` },
        });
    };

    return { loading, error, data, get, post, put, remove };
};

export default useApi;
